export default __webpack_public_path__ + "44b0a8fc974d33f4c496928e931e6c5d.svg";